import { fwgpricecent } from '@/helpers/FilterFwg'

const chfLabelFn = ({percent}, {totalWithoutSurcharges}) => fwgpricecent(Math.round((totalWithoutSurcharges / 100 * percent) / 5) * 5, 'html');
const percentLabelFn = ({percent}) => `${percent}%`;

export const tipVariants = [
	{
		variant: 0,
		subVariants: [
			{
				variant: 0,
        grid: 3,
				options: [
					{
						type: 'chf',
						labelKey: 'checkout.tipOptions.chf',
            options: [
              {
                type: 'chf',
                labelFn: chfLabelFn,
                percent: 7
              },
              {
                type: 'chf',
                labelFn: chfLabelFn,
                percent: 10
              },
              {
                type: 'chf',
                labelFn: chfLabelFn,
                percent: 15
              },
              {
                type: 'chf',
                labelKey: 'checkout.tipOptions.customAmount',
                span: true,
                input: {
                  min: 0,
                  step: 0.05,
                }
              },
            ]
					},
					{
						type: 'percent',
						labelKey: 'checkout.tipOptions.percent',
            options: [
              {
                type: 'percent',
                labelFn: percentLabelFn,
                percent: 7
              },
              {
                type: 'percent',
                labelFn: percentLabelFn,
                percent: 10
              },
              {
                type: 'percent',
                labelFn: percentLabelFn,
                percent: 15
              },
            ]
					},
					{
						type: 'none',
						labelKey: 'checkout.tipOptions.none',
						value: 0,
					},
				]
			},
		]
	},
]

export default tipVariants
